/**
 * Generated file, do not edit directly!
 */

/** Breakpoints are used to adjust the layout and appearance of elements in the interface based on different screen sizes. */

const Max = {
  /**
   * Use with `@media` `max-width` to apply styles to mobile-sized screens.
   * Value: 640.
   */
  Mobile: 640,
  /**
   * Use with `@media` `max-width` to apply styles to tablets and smaller screens.
   * Value: 960.
   */
  Tablet: 960,
  /**
   * Use with `@media` `max-width` to apply styles to desktops and smaller screens.
   * Value: 1920.
   */
  Desktop: 1920,
};
const Min = {
  /**
   * Use this with `@media` `min-width`, to apply styles to tablet and wider screen sizes.
   * Value: 641.
   */
  Tablet: 641,
  /**
   * Use this with `@media` `min-width`, to apply styles to desktop and wider screen sizes.
   * Value: 961.
   */
  Desktop: 961,
  /**
   * Use this with `@media` `min-width`, to apply styles to widescreen desktop and wider screen sizes.
   * Value: 1921.
   */
  Widescreen: 1921,
};
export default {
  Max,
  Min,
};
